/* eslint-disable react/jsx-no-constructed-context-values */
import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Context, { defaults } from './context'
import { getDevelopers } from './controller'
import StepView from '../components/step-view'

function App({
  labels: labelsObject,
  skills: skillsObject,
  roles: rolesObject,
  experience: experienceObject,
  dark: darkMode,
}) {
  const [fetching, setFetching] = useState(defaults.fetching)
  const [developers, setDevelopers] = useState(defaults.developers)
  const [filters, setFilters] = useState(defaults.filters)
  const [selectedDevelopers, setSelectedDevelopers] = useState(defaults.selectedDevelopers)
  const [step, setStep] = useState(defaults.step)

  const labels = labelsObject ? JSON.parse(labelsObject) : {}
  const skills = labelsObject ? JSON.parse(skillsObject) : []
  const roles = labelsObject ? JSON.parse(rolesObject) : []
  const experience = labelsObject ? JSON.parse(experienceObject) : []
  const dark = darkMode === 'true'

  const filterDevelopers = async () => {
    setFetching(true)
    const result = await getDevelopers(filters)
    const { data = [] } = result
    setDevelopers(data)
    setSelectedDevelopers([])
    setFetching(false)
  }

  function isSelected(id, type) {
    return filters[type].includes(id)
  }

  function addFilter(id, type) {
    const newFilters = filters
    newFilters[type].push(id)
    setFilters({ ...newFilters })
  }

  function removeFilter(id, type) {
    const newFilters = filters
    const index = newFilters[type].indexOf(id)
    newFilters[type].splice(index, 1)
    setFilters({ ...newFilters })
  }

  function toggleFilter(id, type) {
    if (isSelected(id, type)) {
      return removeFilter(id, type)
    }
    return addFilter(id, type)
  }

  function toggleDeveloper(devId) {
    const newDevs = selectedDevelopers
    const index = newDevs.indexOf(devId)
    if (index > -1) {
      newDevs.splice(index, 1)
    } else {
      newDevs.push(devId)
    }
    setSelectedDevelopers([...newDevs])
  }

  function reset() {
    setSelectedDevelopers([])
    setFilters(defaults.filters)
  }

  return (
    <Context.Provider
      value={{
        fetching,
        developers,
        filterDevelopers,
        filters,
        isSelected,
        toggleFilter,
        selectedDevelopers,
        toggleDeveloper,
        step,
        setStep,
        reset,
      }}
    >
      <StepView labels={labels} skills={skills} roles={roles} experience={experience} dark={dark} />
    </Context.Provider>
  )
}

App.propTypes = {
  labels: PropTypes.string.isRequired,
  skills: PropTypes.string.isRequired,
  roles: PropTypes.string.isRequired,
  experience: PropTypes.string.isRequired,
  dark: PropTypes.string,
}

App.defaultProps = {
  dark: 'false',
}

export default App
